/*
 *  Licensed under the EUPL, Version 1.2 or – as soon they will be approved by
the European Commission - subsequent versions of the EUPL (the "Licence");
You may not use this work except in compliance with the Licence.
You may obtain a copy of the Licence at:

  https://joinup.ec.europa.eu/software/page/eupl

Unless required by applicable law or agreed to in writing, software
distributed under the Licence is distributed on an "AS IS" basis,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the Licence for the specific language governing permissions and
limitations under the Licence. */

import SvgIcon from "@mui/material/SvgIcon";

export const TicketMachine = (props) => (
  <SvgIcon {...props} viewBox="0 0 41.94 125">
    <rect x="26.543" y="56.41" width="6.045" height="1.626" id="rect4" />
    <path
      d="m 35.274863,10.29661 -28.609958,0 c -2.9681907,0 -5.3745321,2.07211 -5.3745321,4.62864 l 0,99.67221 39.3602541,0 0,-99.67221 c -0.0012,-2.55653 -2.407574,-4.62864 -5.375764,-4.62864 z m 1.25184,63.214425 -9.932166,0 0,-13.732945 9.932166,0 0,13.732945 z m 0,-23.245182 -31.1136377,0 0,-16.224576 31.1124057,0 0,16.224576 z"
      id="path6"
    />
  </SvgIcon>
);
